module.exports = __webpack_public_path__ + "static/media/ck.7ab1552e.svg";